// extracted by mini-css-extract-plugin
export default {"tabContent":"ServiceDetail_tabContent__5h9CA","tabItem":"ServiceDetail_tabItem__8q8FQ"};